import { api } from "../client";

export async function getApplicationDocuments(applicationId) {
  if (!applicationId) return [];

  const filters = JSON.stringify([
    ["attached_to_doctype", "=", "Applications"],
    ["attached_to_name", "=", applicationId],
  ]);

  const response = await api.get("/api/resource/File", {
    params: {
      fields: JSON.stringify([
        "name",
        "file_name",
        "file_url",
        "attached_to_field",
        "is_private",
        "creation",
      ]),
      filters,
      limit_page_length: 100,
    },
  });

  return response?.data?.data || response?.data?.message?.data || [];
}
